import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Work, WorkOutline } from '@material-ui/icons';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { FORM_MAX_WIDTH, SelectEntityOption } from '../../../utils/constants';
import { OneToolCard } from './oneToolCard';

const useStyles = makeStyles(theme => ({
  button: {
    width: '358px',
    margin: '0 auto',
    border: '1px solid rgba(88, 171, 222, 1)',
    boxShadow: 'box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);',
    color: 'black',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 400,
  },
}));

interface CardProps {
  option: SelectEntityOption;
  onSelect: (option: SelectEntityOption) => void;
}

export const SelectEntityOptionCard = observer(
  ({ option, onSelect }: CardProps) => {
    const classes = useStyles();
    return (
      <OneToolCard
        maxWidth={FORM_MAX_WIDTH}
        center
        title={'Choose from the options below.'}
        subtitle={
          'As a business-purpose lender, we require closing in a corporation or LLC.'
        }
      >
        <Grid container spacing={2} direction="column" alignItems="center">
          <Grid item>
            <Button
              testId="search-existing"
              variant="outlined"
              color="primary"
              fullWidth
              className={classes.button}
              onClick={() => onSelect(SelectEntityOption.SEARCH_ENTITY)}
            >
              Search an Existing Entity
            </Button>
          </Grid>
          <Grid item>
            <Button
              testId="search-existing"
              variant="outlined"
              color="primary"
              fullWidth
              className={classes.button}
              onClick={() => onSelect(SelectEntityOption.ADD_ENTITY)}
            >
              Enter Entity Information
            </Button>
          </Grid>
          <Grid item>
            <Button
              testId="search-existing"
              variant="outlined"
              color="primary"
              fullWidth
              className={classes.button}
              onClick={() => onSelect(SelectEntityOption.NO_ENTITY)}
            >
              I don't have an entity yet
            </Button>
          </Grid>
        </Grid>
      </OneToolCard>
    );
  }
);
